// Module-level store for Chrome's beforeinstallprompt (spec v2 §16.3). The event fires once per page load,
// usually before any component mounts, so it is captured in main.tsx and read by useInstallPrompt.
export type BIPEvent = Event & { prompt: () => Promise<void>; userChoice: Promise<{ outcome: "accepted" | "dismissed" }> };

let deferred: BIPEvent | null = null;
let started = false;
const listeners = new Set<() => void>();
const emit = () => listeners.forEach((l) => l());

export function captureInstallPrompt(): void {
  if (started || typeof window === "undefined") return;
  started = true;
  window.addEventListener("beforeinstallprompt", (e) => { e.preventDefault(); deferred = e as BIPEvent; emit(); });
  window.addEventListener("appinstalled", () => { deferred = null; emit(); });
}
export const getInstallPrompt = (): BIPEvent | null => deferred;
export const clearInstallPrompt = (): void => { deferred = null; emit(); };
export function subscribeInstallPrompt(l: () => void): () => void { listeners.add(l); return () => { listeners.delete(l); }; }
